/**
 * 渠道信息
 * auin 缓存用户auin，现在逻辑不变
 * sourcetype 
 *   缓存用户首次进入的渠道类型 跟uin透传，随cookie失效
 *   按照优先级
 *   若url中有saleToken，则'saleToken'
 *   若url中有flowToken，则'flowToken'
 *   若url中有tuin，则'tuin'
 *   若url中有from，则'from'
 *   要启用屏幕阅读器支持，请按⌘+Option+Z。要了解键盘快捷键，请按⌘斜杠。
 * sourcefrom
 *   缓存用户首次进入的渠道值 跟uin透传，随cookie失效
 *   按照优先级
 *   若url中有saleToken，则'saleToken'
 *   若url中有flowToken，则'flowToken'
 *   若url中有tuin，则'tuin'
 *   若url中有from，则'from'
 *   要启用屏幕阅读器支持，请按⌘+Option+Z。要了解键盘快捷键，请按⌘斜杠。
 * @Author: moonye
 * @Date: 2018-06-20 10:56:27
 * @Last Modified by: moonye
 * @Last Modified time: 2018-07-30 21:00:45
 */

import { query, getHash } from './util.bom';

const DEFAULT = '-';

function getSourceData() {
  const sourceList = ['saleToken', 'flowToken', 'tuin', 'from'];
  for (let s = 0, sLen = sourceList.length; s < sLen; s++) {
    const v = sourceList[s];
    const t = query(v);
    if (t) {
      return {
        sourcetype: v,
        sourcefrom: t,
      }
    }
  }
  return {};
}

function getAuin() {
  let tuin = query('tuin') || getHash('tuin');
  return +('0x' + tuin).toString(10);
}

export default function (dataFromCookie) {
  dataFromCookie = dataFromCookie || {};
  
  const sourceData = getSourceData();
  const auin = getAuin();

  dataFromCookie.auin = dataFromCookie.auin || auin || DEFAULT;
  dataFromCookie.sourcetype = dataFromCookie.sourcetype || sourceData.sourcetype || '';
  dataFromCookie.sourcefrom = dataFromCookie.sourcefrom || sourceData.sourcefrom || '';

  return dataFromCookie;
};